import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'

const { unit } = measures

export const container = css`
  margin-bottom: ${spacing(3)};
`

export const filtersWrapper = css`
  display: flex;
  gap: ${spacing(1)};
  overflow-x: auto;
  padding: ${spacing(0, 0, 1, 0)};
  
  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const filterPill = css`
  display: flex;
  align-items: center;
  gap: ${spacing(0.75)};
  padding: ${spacing(1, 1.5)};
  border-radius: ${spacing(2)};
  border: 1px solid ${colors.grays.gray7};
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    background-color: ${colors.grays.gray9};
  }
  
  &:focus {
    outline: none;
    border-color: ${colors.greens.green6};
  }
`

export const filterPillActive = css`
  background-color: ${colors.greens.green7};
  border-color: ${colors.greens.green7};
  
  &:hover {
    background-color: ${colors.greens.green7};
  }
`

export const filterIcon = css`
  width: ${spacing(3.5)};
  height: ${spacing(3.5)};
  transform: translateY(-0.5px);
  
  & svg {
    width: 100%;
    height: 100%;
    
    path {
      fill: ${colors.white60};
    }
  }
`

export const filterIconActive = css`
  width: ${spacing(3.5)};
  height: ${spacing(3.5)};
  transform: translateY(-0.5px);
  
  & svg {
    width: 100%;
    height: 100%;
    
    path {
      fill: ${colors.white100};
    }
  }
`

export const filterText = css`
  color: ${colors.white60};
  line-height: 1;
`

export const filterTextActive = css`
  color: ${colors.white100};
` 